module.exports = __webpack_public_path__ + "img/news-10.d336ae51.jpg";